/** Captured from Clients List Export Settings modal. */
export const LIST_EXPORT_SETTINGS = {
  "dccId": "129",
  "exportId": "62",
  "rows": [
    {
      "value": "NAME",
      "label": "CLIENT NAME",
      "priority": "2",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "FIRST NAME",
      "label": "FIRST NAME",
      "priority": "3",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "LAST NAME",
      "label": "LAST NAME",
      "priority": "4",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MIDDLE INITIAL",
      "label": "MIDDLE INITIAL",
      "priority": "5",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "DATE OF BIRTH",
      "label": "DATE OF BIRTH",
      "priority": "6",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "GENDER",
      "label": "GENDER",
      "priority": "7",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "SOCIAL SECURITY NO",
      "label": "SOCIAL SECURITY NO",
      "priority": "8",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ADDRESS1",
      "label": "ADDRESS1",
      "priority": "9",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ADDRESS2",
      "label": "ADDRESS2",
      "priority": "10",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "CITY",
      "label": "CITY",
      "priority": "11",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "STATE",
      "label": "STATE",
      "priority": "12",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ZIP CODE",
      "label": "ZIP CODE",
      "priority": "13",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MEDICAID ID #",
      "label": "MEDICAID ID #",
      "priority": "18",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "HMO ID #",
      "label": "HMO ID #",
      "priority": "19",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PAYER NAME",
      "label": "PAYER NAME",
      "priority": "20",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PAYER ID",
      "label": "PAYER ID",
      "priority": "21",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "FOOD PROGRAM",
      "label": "FOOD PROGRAM",
      "priority": "22",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "DIET PLAN",
      "label": "DIET PLAN",
      "priority": "23",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "CLIENT_ID",
      "label": "CLIENT #",
      "priority": "24",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MLTSS",
      "label": "MLTSS",
      "priority": "25",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ADMISSION DATE",
      "label": "ADMISSION DATE",
      "priority": "26",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "DISCHARGED DATE",
      "label": "DISCHARGED DATE",
      "priority": "27",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PHYSICIAN NAME",
      "label": "PHYSICIAN NAME",
      "priority": "28",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "EMERGENCY CONTACT NAME",
      "label": "EMERGENCY CONTACT NAME",
      "priority": "29",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "EMERGENCY CONTACT",
      "label": "EMERGENCY CONTACT #",
      "priority": "30",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "DIAGNOSIS",
      "label": "DIAGNOSIS",
      "priority": "31",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "SCHEDULE",
      "label": "SCHEDULE (Days as ADC)",
      "priority": "32",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PHYSICIAN NUMBER",
      "label": "PHYSICIAN NUMBER",
      "priority": "33",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MEDICARE NUMBER",
      "label": "MEDICARE NUMBER",
      "priority": "34",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MARITAL STATUS",
      "label": "MARITAL STATUS",
      "priority": "35",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PHONE NO",
      "label": "PHONE NO",
      "priority": "36",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "CELL PHONE NO",
      "label": "CELL PHONE NO",
      "priority": "37",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "HOME HEALTH AIDE",
      "label": "HOME HEALTH AIDE",
      "priority": "38",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PHYSICIAN FAX",
      "label": "PHYSICIAN FAX",
      "priority": "39",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PHARMACY",
      "label": "PHARMACY",
      "priority": "40",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "CODE STATUS",
      "label": "CODE STATUS",
      "priority": "41",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ALLERGIES",
      "label": "ALLERGIES",
      "priority": "42",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "HOSPITAL PREFERENCE",
      "label": "HOSPITAL PREFERENCE",
      "priority": "43",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "GUARDIAN",
      "label": "GUARDIAN",
      "priority": "44",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "EMAIL ID",
      "label": "EMAIL ID",
      "priority": "45",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "LOC",
      "label": "LOC",
      "priority": "46",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "CARE MANAGER",
      "label": "CARE MANAGER",
      "priority": "47",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ELIGIBILITY DATE",
      "label": "ELIGIBILITY DATE",
      "priority": "48",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "TRANSPORTATION BROKER",
      "label": "TRANSPORTATION BROKER",
      "priority": "49",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "COUNTRY",
      "label": "COUNTRY",
      "priority": "50",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MOBILITY ID NUMBER",
      "label": "MOBILITY ID NUMBER",
      "priority": "51",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "CLIENT SHIFT",
      "label": "CLIENT SHIFT",
      "priority": "52",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "STATUS",
      "label": "STATUS",
      "priority": "53",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "STATUS DATE",
      "label": "STATUS DATE",
      "priority": "54",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "NO OF DAYS APPROVED",
      "label": "NO OF DAYS APPROVED",
      "priority": "55",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "PICKUP ROUTE",
      "label": "PICKUP ROUTE",
      "priority": "56",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "DROPOFF ROUTE",
      "label": "DROPOFF ROUTE",
      "priority": "57",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "PICKUP DRIVER",
      "label": "PICKUP DRIVER",
      "priority": "58",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "DROPOFF DRIVER",
      "label": "DROPOFF DRIVER",
      "priority": "59",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "CASE MANAGER NAME",
      "label": "CASE MANAGER NAME",
      "priority": "60",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "CASE MANAGER PHONE",
      "label": "CASE MANAGER PHONE",
      "priority": "61",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "CASE MANAGER EMAIL",
      "label": "CASE MANAGER EMAIL",
      "priority": "62",
      "checked": false,
      "priorityDisabled": true
    }
  ]
} as const
